/**
 * Очередь загрузки картинок сетки: не больше `MAX_ACTIVE` запросов разом и темп,
 * который пропускает шлюз (корзина жетонов `BURST`/`RATE`).
 *
 * Шлюз домена режет и одновременность, и темп (nginx → 429). С 07.10.26 `/thumb/`
 * и `/media/` идут через зону `img_rl`: 20 запросов/с, запас 500, и общий
 * `limit_conn` 20 соединений на сотрудника (контракт
 * reels/docs/contracts/2026-10-07-urtinfra-reels-image-rate-limit.md). Корзина
 * повторяет лимит шлюза: экран, на котором остановились, грузится сразу из
 * запаса, а при долгой прокрутке темп сам опускается до 20/с — и 429 не бывает.
 * Запас взят с полуторным зазором (300 из 500): лимит общий у всех вкладок
 * сотрудника. 16 разом — остальные соединения остаются ручкам `/api`.
 * Без очереди браузер по HTTP/2 шлёт сотни ленивых превью разом — часть
 * плиток оставалась пустой.
 *
 * Ждущих обслуживаем с конца: последней место попросила плитка, на которую
 * смотрят сейчас, а пролистанные подождут.
 */
const MAX_ACTIVE = 16;
export const BURST = 300;
export const RATE = 20; // жетонов в секунду

/** Корзина жетонов к моменту `now`: пополнение темпом `RATE`, не выше `BURST`. */
export function refill(tokens: number, lastMs: number, nowMs: number): number {
  return Math.min(BURST, tokens + ((nowMs - lastMs) / 1000) * RATE);
}

let active = 0;
let tokens = BURST;
let stamp = Date.now();
let timer: number | undefined;
const waiting: (() => void)[] = [];

function pump() {
  if (timer !== undefined) return;
  while (active < MAX_ACTIVE && waiting.length) {
    const now = Date.now();
    tokens = refill(tokens, stamp, now);
    stamp = now;
    if (tokens < 1) {
      timer = window.setTimeout(
        () => {
          timer = undefined;
          pump();
        },
        Math.ceil(((1 - tokens) / RATE) * 1000),
      );
      return;
    }
    tokens -= 1;
    waiting.pop()!();
  }
}

/** Занять место; вернёт функцию, которая место освобождает (повторный вызов безвреден). */
export function acquireSlot(): Promise<() => void> {
  return new Promise((resolve) => {
    waiting.push(() => {
      active++;
      let done = false;
      resolve(() => {
        if (done) return;
        done = true;
        active--;
        pump();
      });
    });
    pump();
  });
}
